import { Reducer } from 'redux';
import { keyBy, omit } from 'lodash';
import { all, takeLatest } from 'redux-saga/effects';
import {
  LocationsV2State,
  LocationsV2Actions,
  LocationsV2ActionTypes,
} from './locations.types';

export const locationsV2Reducer: Reducer<LocationsV2State, LocationsV2Actions> = (
  state = {},
  action
) => {
  switch (action.type) {
    case LocationsV2ActionTypes.AddLocationsV2:
      return {
        ...state,
        ...keyBy(action.payload, (location) => location.locationId),
      };
    case LocationsV2ActionTypes.RemoveLocationV2:
      return omit(state, action.payload);
    case LocationsV2ActionTypes.UpdateLocationV2: {
      const location = state[action.payload.locationId];
      return location
        ? {
            ...state,
            [action.payload.locationId]: { ...location, ...action.payload.location },
          }
        : state;
    }
    default:
      return state;
  }
};
